// src/components/BottomNav.js

import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import {
  IoHomeOutline,
  IoBarbellOutline,
  IoRestaurantOutline,
  IoCalendarOutline,
  IoBookOutline,
  IoLogOutOutline,
  IoTrendingUpOutline,
  IoPeopleOutline,
} from 'react-icons/io5';
import { useAuthContext } from '../context/AuthContext';

const BottomNav = () => {
  const { logout, user } = useAuthContext();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const activeLinkClasses = 'text-white bg-marizan-red/80';
  const inactiveLinkClasses = 'text-gray-400 hover:text-white';

  const allNavLinks = [
    { to: '/dashboard', icon: IoHomeOutline, text: 'Dashboard', roles: ['coach', 'client', 'admin'] },

    // Coach
    { to: '/clients', icon: IoBarbellOutline, text: 'Clientes', roles: ['coach', 'admin'] },
    { to: '/programs', icon: IoBookOutline, text: 'Programas', roles: ['coach'] },
    { to: '/nutrition-plans', icon: IoRestaurantOutline, text: 'Nutrición', roles: ['coach'] },

    // Admin
    { to: '/admin/users', icon: IoPeopleOutline, text: 'Usuarios', roles: ['admin'] },

    // Cliente
    { to: '/my-training', icon: IoBarbellOutline, text: 'Entreno', roles: ['client'] },
    { to: '/my-progress', icon: IoTrendingUpOutline, text: 'Progreso', roles: ['client'] },
    { to: '/nutrition', icon: IoRestaurantOutline, text: 'Nutrición', roles: ['client'] },
    { to: '/calendar', icon: IoCalendarOutline, text: 'Calendario', roles: ['client'] },
  ];

  const visibleNavLinks = allNavLinks.filter((link) => link.roles.includes(user?.role));

  return (
    <nav className="sticky bottom-0 w-full bg-black/50 backdrop-blur-xl border-t border-white/10 shadow-2xl z-50">
      <div className="container mx-auto grid h-16" style={{ gridTemplateColumns: `repeat(${visibleNavLinks.length + 1}, minmax(0, 1fr))` }}>
        {visibleNavLinks.map((link, index) => (
          <NavLink
            key={link.to}
            to={link.to}
            className={({ isActive }) =>
              `flex flex-col items-center justify-center transition-colors ${index > 0 ? 'border-l border-white/10' : ''} ${isActive ? activeLinkClasses : inactiveLinkClasses}`
            }
          >
            <link.icon size={24} />
            <span className="text-xs mt-1">{link.text}</span>
          </NavLink>
        ))}

        <button
          onClick={handleLogout}
          className="flex flex-col items-center justify-center border-l border-white/10 text-gray-400 hover:text-marizan-red transition-colors"
        >
          <IoLogOutOutline size={24} />
          <span className="text-xs mt-1">Salir</span>
        </button>
      </div>
    </nav>
  );
};

export default BottomNav;
